export default __webpack_public_path__ + "media/environment_friendly_banner_mobile_en.5ea9a9b7.png";